import {ReactEventHandler, SyntheticEvent} from 'react';
import {aggregateAndSendLog} from './aggregateAndSendLog';
import {debuggingFeature} from './debuggingFeature.variable';
import {TrackEventObject} from './TrackEventObject.interface';

/**
 * 아무 '클릭' 이벤트나 쉽게 넣을 수 있는 헬퍼
 */
export const LOG_CLICK_EVENT = (
  actionName: string,
  e: SyntheticEvent,
  eventHandler?: ReactEventHandler
) => {
  return logEvent({
    e,
    actionType: 'Event',
    actionName,
    customProps: {
      user_action: 'click',
    },
    eventHandler,
  });
};

/**
 * '작품_클릭'을 넣을 때 사용하면 편리한 헬퍼
 */
export const LOG_SERIES_CLICK = (
  e: SyntheticEvent,
  eventHandler?: ReactEventHandler
) => {
  return logEvent({
    e,
    actionType: 'Event',
    actionName: '작품_클릭',
    customProps: {
      user_action: 'click',
    },
    eventHandler,
  });
};

export const LOG_PRODUCT_CLICK = (
  e: SyntheticEvent,
  eventHandler?: ReactEventHandler
) => {
  return logEvent({
    e,
    actionType: 'Event',
    actionName: '회차_클릭',
    customProps: {
      user_action: 'click',
    },
    eventHandler,
  });
};

export const LOG_MORE_CLICK = (
  e: SyntheticEvent,
  eventHandler?: ReactEventHandler
) => {
  return logEvent({
    e,
    actionType: 'Event',
    actionName: '더보기_클릭',
    customProps: {
      user_action: 'click',
    },
    eventHandler,
  });
};

export const LOG_SEARCH_CLICK = (
  actionName: string,
  e: SyntheticEvent,
  eventHandler?: ReactEventHandler,
  customOptions?: {
    customPage?: TrackEventObject['page'];
  }
) => {
  return logEvent({
    e,
    actionType: 'Event',
    actionName,
    customProps: {
      user_action: 'click',
    },
    eventHandler,
    customSection: '검색',
    customPage: customOptions?.customPage,
  });
};
export function logEvent({
  e,
  actionType,
  actionName,
  customProps,
  eventHandler,
  customSection,
  customPage,
}: {
  e: SyntheticEvent;
  // Pageview는 TrackPageViewContainer를 통해서만 로깅 가능합니다.
  actionType: Exclude<TrackEventObject['actionType'], 'Pageview'>;
  actionName: string;
  customProps: TrackEventObject['customProps'];
  eventHandler?: ReactEventHandler;
  customSection?: TrackEventObject['section'];
  customPage?: TrackEventObject['page'];
}) {
  if (debuggingFeature.ignoreDefaultEvent) {
    e.preventDefault();
    e.stopPropagation();
  } else {
    eventHandler?.(e);
  }
  aggregateAndSendLog({
    targetElem: e.currentTarget as HTMLElement,
    actionType,
    actionName,
    customProps,
    customSection,
    customPage,
  });
}
